import AsyncStorage from "@react-native-async-storage/async-storage";
import { clientConfigPath, currentIP, ISINROOMTAB, MOBILE_CHECKIN_CATEGORY } from "../../config/Constant";
import { logoutUserFunc } from "./roomLinkingAction";
import { setInitAppLogout, setIsAutoLoggedIn } from "../Reducers/appConfigReducer";
import { setProceedLoginToTheApp } from "./appConfigAction";
import { sendAnalytics } from "./analyticsAction";
import { makeLayoutApiCalls } from "../../js/fetchAppConfigs";

export const checkAppHealthService = () => {


    return async (dispatch, getState) => {

        const { isLoggedIn } = getState().appConfigSlice;
        const { isBookingFound, bookingData } = getState().checkInSlice.bookingStatus;
        const { currentGuestDetails } =  getState().guestDetailsSlice;

        const { currentLayoutId } = getState().deviceConfigSlice;

        const layoutId = currentLayoutId || await AsyncStorage.getItem('currentLayoutId');

        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const deviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');

        let room = await AsyncStorage.getItem('room');
        room = room && room !== "null" ? room : "notLogin";

        let roomID = await AsyncStorage.getItem('roomID');


        if (!roomID && (!isLoggedIn && !isBookingFound)) {
            return;
        }


        const handleLogoutCallback = (status, error) => {
            console.log("webappping Logout callback", status, error);
        }

        try {
            const response = await clientConfigPath.post(
                `/core/webAppPing?dId=${deviceIdentifier}&rn=${room}`,
                {
                    header: { sessionToken },
                    payload: {
                        ipAddress: currentIP,
                        isInRoomMobileDevice: ISINROOMTAB,
                        bookingNumber: bookingData?.confirmationNumber ?? null,
                        layoutId: layoutId,
                    }
                }
            );

            const payload = response?.data?.payload;
            if (!payload) return;


            if(!payload.isGuestCheckedIn && isLoggedIn){
                dispatch(logoutUserFunc(handleLogoutCallback));
                return;
            }

            // Handle queued commands
            if (payload.commands?.length > 0) {
                const commands = [...payload.commands].sort((a, b) => a.priority - b.priority);

                console.log("dmq commands received", commands);
                commands.forEach(async (cmd) => {
                    console.log("res webAppPing triggered", cmd.type);

                    switch (cmd.type) {
                        case "DEVICE_REGISTRATION":
                            let locationId = cmd?.params?.locationId;
                            if(locationId){
                                await AsyncStorage.setItem("roomID", locationId);
                                dispatch(setInitAppLogout(true));
                            }
                            break;
                            
                        case "QUEUED_GUEST_CHECKED_IN":
                            dispatch(setProceedLoginToTheApp(true, { lastName: bookingData?.lastName, confirmationNumber: bookingData?.confirmationNumber, checkinDate: bookingData?.checkinDate, roomNumber: cmd.params?.roomNumber, candoAccompanyLogin: false, candoOtpFlow: false }));
                            dispatch(setIsAutoLoggedIn(true));
                            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "Auto Login - Attempted", {lastName: bookingData?.lastName, confirmationNumber: bookingData?.confirmationNumber, checkinDate: bookingData?.checkinDate, roomNumber: cmd.params?.roomNumber}));
                            break;
                        
                        case "GUEST_CHECK_OUT":
                            dispatch(setInitAppLogout(true));
                            break;
                    }
                });
            }

        } catch (error) {
            const status = error?.response?.status;
            console.log("HealthService Api failed with the status code:", status);

            if (status === 401) {
                dispatch(setInitAppLogout(true));
            } else {
                console.error(`Error in HealthService`, error);
            }
        }
    };
}